import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/components/capstone/base';
import { StandardToastBody } from '@rsos/components/capstone/base/Toast/ToastComponents';
import { useKeywordSets } from '@rsos/reduxDataStore/src/features/keywords';
import {
  Wrapper,
  Message,
  KeywordChip,
  CallerId,
} from './KeywordNotification.styles';
import type { KeywordDetectionMessage } from './keywordNotificationsSlice';

interface KeywordNotificationProps {
  match: KeywordDetectionMessage;
}

export function KeywordNotification({
  match,
}: KeywordNotificationProps): JSX.Element {
  const { keywordSetMap } = useKeywordSets();
  const keywordSet = keywordSetMap[match.keywordSetId];
  const tierId = keywordSet?.tier_id || 'tier-1';

  return (
    <StandardToastBody
      message={() => (
        <Wrapper>
          <Message>
            <KeywordChip tierId={tierId} title={match.keywordSetName}>
              {match.keywordSetName}
            </KeywordChip>{' '}
            keyword detected from call{' '}
            <CallerId title={match.callerId}>{match.callerId}</CallerId>
          </Message>
          <Button size="small" px={20}>
            View call
          </Button>
        </Wrapper>
      )}
      icon={() => <AttentionTriangleIcon width={20} height={20} />}
    />
  );
}
